import { makeStyles } from "@mui/styles";
import {
  Badge,
  Box,
  Checkbox,
  FormControlLabel,
  Icon,
  IconButton,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Cancel,
  Check,
  CopyAll,
  Create,
  Delete,
  ExpandLess,
  ExpandMore,
  Restore,
  PictureAsPdf,
  WhatsApp,
  Email,
  Error,
  Pending,
} from "@mui/icons-material";
import React, { memo, useContext, useState } from "react";
import { withRouter } from "react-router";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import { tienePermisoRuta } from "../../../../config/validaciones";
import AuthContext from "../../../../Context/Auth/AuthContext";
import MenuContext from "../../../../Context/Menu/MenuContext";
import { permisoDenagado, serverphpvet } from "../../../../config/const";
import { ModalContactoPlantillaW } from "../../../components/Modal/ModalContactoPlantillaW";
import ModalEmail from "../../../../components/Extra/ModalEmail";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const ButtonsAction = (props) => {
  const {
    arrayExport,
    setarrayExport,
    campoExport,
    row,
    setopenConfirmDialog,
    funcionEdit,
    ocultarEditar,
    ocultarDelete,
    mostrarEstado,
    campoEstado,
    editar,
    funcCancel,
    funcSubmit,
    botonDisabled,
    puedeExportar,
    desdeOtroLugar,
    expandir,
    setexpandir,
    funcionCopiar,
    eliminadoEstado,
  } = props;
  const classes = useRowStyles();
  const { usuario } = useContext(AuthContext);
  const { rows } = useContext(MenuContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  const [openModalEmail, setopenModalEmail] = useState(false);
  const [
    openModalContactoPlantillaW,
    setopenModalContactoPlantillaW,
  ] = useState(false);
  const contactoDefault = {
    medioComunicacion: "Whatsapp",
    option: "Historia Clinica",
    idRegistro: row.hcliId,
    contacto: [],
    contenidoMensaje: "",
  };
  const [newContacto, setNewContacto] = useState(contactoDefault);
  const [correoEnviado, setcorreoEnviado] = useState(false);

  return (
    <>
      {openModalEmail && (
        <ModalEmail
          open={openModalEmail}
          setopen={setopenModalEmail}
          id={row.hcliId}
          documento={"HistoriaClinica"}
          emailDefecto={row.hcliPerEmail}
          campos={[
            {
              label: "Documento",
              propiedad: "Historia Clinica",
            },

            {
              label: "Propietario",
              propiedad: row.hcliPerNombre,
            },
            {
              label: "Mascota",
              propiedad: row.hcliMascNombre,
            },
          ]}
          funcSuccess={() => setcorreoEnviado(true)}
        />
      )}
      {openModalContactoPlantillaW && (
        <ModalContactoPlantillaW
          personaId={row.hcliPerId}
          encabezado={[
            { label: "Documento Propietario:", value: row.hcliPerDocumento },
            {
              label: "Propietario:",
              value: row.hcliPerNombre,
            },
            {
              label: "Paciente:",
              value: row.hcliMascNombre,
            },
            {
              label: "#Carnet:",
              value: row.hcliMascId,
            },
          ]}
          row={row}
          open={openModalContactoPlantillaW}
          setopen={setopenModalContactoPlantillaW}
          newContacto={newContacto}
          setNewContacto={setNewContacto}
          contactoDefault={contactoDefault}
          objetoPlantilla={"empPlantillaHistoriaClinica"}
        />
      )}
      {arrayExport ? (
        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
            maxWidth: "1rem",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <FormControlLabel
              className={classes.margin}
              control={
                <Checkbox
                  size="small"
                  disabled={!puedeExportar && desdeOtroLugar}
                  className={classes.margin}
                  checked={arrayExport.some((item) => {
                    return item === row[campoExport];
                  })}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setarrayExport([...arrayExport, row[campoExport]]);
                    } else {
                      setarrayExport(
                        arrayExport.filter((item) => item !== row[campoExport])
                      );
                    }
                  }}
                  color="secondary"
                />
              }
            />
          </Box>
        </TableCell>
      ) : null}
      <TableCell padding="none" style={{ borderRight: "1px solid #ccc" }}>
        <Box display="flex" alignItems="center">
          {eliminadoEstado ? (
            <>
              <Tooltip title="Ver" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    if (
                      !tienePermisoRuta(
                        rows,
                        props.location.pathname,
                        usuario.rol,
                        "editar"
                      )
                    ) {
                      return mostrarAlerta(permisoDenagado, "error");
                    }
                    funcionEdit();
                  }}
                >
                  <Restore color="success" />
                </IconButton>
              </Tooltip>
              <Tooltip title="PDF" arrow>
                <IconButton
                  className={classes.margin}
                  size="small"
                  onClick={() => {
                    // Abres la nueva ventas
                    window.open(
                      `${serverphpvet}reportes/historiaIndividual.php?id=${row.hcliId}&empresa=${row.hcliEmpresa}`,
                      "_blank"
                    );
                  }}
                >
                  <PictureAsPdf color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              <>
                {editar ? (
                  <>
                    <IconButton
                      className={classes.margin}
                      onClick={() => {
                        funcCancel();
                      }}
                    >
                      <Cancel fontSize="small" color="secondary" />
                    </IconButton>
                    <IconButton
                      className={classes.margin}
                      disabled={botonDisabled ? botonDisabled() : false}
                      onClick={() => {
                        funcSubmit();
                      }}
                    >
                      <Check
                        fontSize="small"
                        color={
                          botonDisabled
                            ? botonDisabled()
                              ? "inherit"
                              : "secondary"
                            : "secondary"
                        }
                      />
                    </IconButton>
                  </>
                ) : (
                  <>
                    {ocultarDelete ? null : (
                      <IconButton
                        className={classes.margin}
                        onClick={() => {
                          if (
                            !tienePermisoRuta(
                              rows,
                              props.location.pathname,
                              usuario.rol,
                              "eliminar"
                            )
                          ) {
                            return mostrarAlerta(permisoDenagado, "error");
                          }
                          setopenConfirmDialog(true);
                        }}
                      >
                        <Delete fontSize="small" color="error" />
                      </IconButton>
                    )}
                    {ocultarEditar ? null : (
                      <IconButton
                        className={classes.margin}
                        onClick={() => {
                          if (
                            !tienePermisoRuta(
                              rows,
                              props.location.pathname,
                              usuario.rol,
                              "editar"
                            )
                          ) {
                            return mostrarAlerta(permisoDenagado, "error");
                          }
                          funcionEdit();
                        }}
                      >
                        <Create color="secondary" />
                      </IconButton>
                    )}
                  </>
                )}
              </>
              <Tooltip title="PDF" arrow>
                <IconButton
                  className={classes.margin}
                  size="small"
                  onClick={() => {
                    // Abres la nueva ventas
                    window.open(
                      `${serverphpvet}reportes/historiaIndividual.php?id=${row.hcliId}&empresa=${row.hcliEmpresa}`,
                      "_blank"
                    );
                  }}
                >
                  <PictureAsPdf color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Copiar" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    funcionCopiar();
                  }}
                >
                  <CopyAll color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title={expandir ? "Contraer" : "Expandir"} arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    setexpandir(!expandir);
                  }}
                >
                  {expandir ? (
                    <ExpandLess color="primary" />
                  ) : (
                    <ExpandMore color="primary" />
                  )}
                </IconButton>
              </Tooltip>
              {row.hcliArchivo && usuario.rucempresa === "MEDIPET" && (
                <Badge
                  badgeContent={
                    row.hcliEstadoCorreo === "ENVIADO" || correoEnviado ? (
                      <>
                        <Icon color="success" fontSize="small">
                          <Check color="success" fontSize="small" />
                        </Icon>
                      </>
                    ) : row.hcliEstadoCorreo === "ERROR" ? (
                      <Icon color="error" fontSize="small">
                        <Pending color="error" fontSize="small" />
                      </Icon>
                    ) : null
                  }
                >
                  <Tooltip title="Enviar Correos" arrow>
                    <IconButton
                      className={classes.margin}
                      onClick={() => {
                        setopenModalEmail(true);
                      }}
                    >
                      <Email color="secondary" />
                    </IconButton>
                  </Tooltip>
                </Badge>
              )}
              <Tooltip title="Mensaje whatsapp" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    setopenModalContactoPlantillaW(true);
                  }}
                >
                  <WhatsApp color="success" />
                </IconButton>
              </Tooltip>
              {mostrarEstado ? (
                <FormControlLabel
                  disabled
                  className={classes.margin}
                  control={
                    <Checkbox
                      value="ACTIVO"
                      className={classes.margin}
                      checked={
                        row[campoEstado] === "ACTIVA" ||
                        row[campoEstado] === "ACTIVO"
                          ? true
                          : false
                      }
                      color="primary"
                    />
                  }
                />
              ) : null}
            </>
          )}
        </Box>
      </TableCell>
    </>
  );
};

export default withRouter(memo(ButtonsAction));
